var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-style-container",class:_vm.contentType === '3D' ? 'media-style-threeD-container' : ''},[_c('div',{staticClass:"media-title",style:({
      fontFamily: _vm.content.titleStyle.fontFamily || '',
      fontSize: (_vm.content.titleStyle.fontSize + 'rem') || '',
      lineHeight: (_vm.content.titleStyle.lineHeight + 'rem') || '',
      textIndent: (typeof _vm.content.titleStyle.textIndent === 'string') ? _vm.content.titleStyle.textIndent :
        (typeof _vm.content.titleStyle.textIndent === 'number') ? (_vm.content.titleStyle.textIndent + 'rem') : '',
      fontWeight: _vm.content.titleStyle.fontWeight || '',
      textDecoration: _vm.content.titleStyle.underline === 1 ? 'underline' : '',
      fontStyle: _vm.content.titleStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: _vm.content.titleStyle.textAlign || '',
      color: _vm.content.titleStyle.color || '',
      backgroundColor: _vm.content.titleStyle.backgroundColor || '',
    }),domProps:{"innerHTML":_vm._s(_vm.content.title)}}),_c('div',{staticClass:"media-button",on:{"click":function($event){$event.stopPropagation();return (function (e) {
      _vm.findChapterFrom(e)
      _vm.$emit('dialogOpen')
    })($event)}}},[_vm._v(_vm._s(_vm.contentType === '3D' ? '点击查看' : '点击播放'))])])}
var staticRenderFns = []

export { render, staticRenderFns }